import { DeferHandler } from './defer-handler.js';
export class ImmediateDeferHandler extends DeferHandler {
    setHandler() {
        return new Promise((resolve) => {
            resolve();
        });
    }
}
//# sourceMappingURL=immediate-defer-handler.js.map